export default "__VITE_ASSET__CbE1wamh__"